/** Prix en euros au format français : virgule décimale et espace insécable
 *  avant le symbole (19,95 €). `toFixed(2)` produisait « 19.95 € », un point
 *  décimal anglo-saxon sur une boutique FR-only. */
export const formatPrice = (value) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(value) || 0);
